var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_shop",
    "data-name": "vuesax/outline/shop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.99,27.63H15.84C4.725,27.63,0,22.882,0,11.79V1.688A1.7,1.7,0,0,1,1.688,0,1.7,1.7,0,0,1,3.375,1.688v10.1c0,9.2,3.262,12.465,12.465,12.465H27.967c9.2,0,12.465-3.262,12.465-12.465V1.688a1.688,1.688,0,0,1,3.375,0v10.1C43.83,22.882,39.082,27.63,27.99,27.63Z",
    transform: "translate(5.085 23.558)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.462,25.875A8.334,8.334,0,0,1,.047,16.56L1.554,1.53A1.706,1.706,0,0,1,3.242,0H13.749a1.688,1.688,0,0,1,1.688,1.53l1.507,15.03a8.414,8.414,0,0,1-2.093,6.57A8.622,8.622,0,0,1,8.462,25.875ZM4.749,3.375,3.4,16.9a5.03,5.03,0,0,0,1.238,3.96,5.4,5.4,0,0,0,7.65,0,5.083,5.083,0,0,0,1.238-3.96L12.174,3.375Z",
    transform: "translate(18.538 2.813)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M10.7,25.875A9.367,9.367,0,0,1,1.583,17.64L.008,1.867A1.737,1.737,0,0,1,.435.563,1.654,1.654,0,0,1,1.7,0H8.558c6.615,0,9.7,2.767,10.62,9.563l.63,6.255A9.025,9.025,0,0,1,10.7,25.875ZM3.563,3.375,4.958,17.3A5.98,5.98,0,0,0,10.7,22.5a5.635,5.635,0,0,0,5.76-6.345l-.63-6.188c-.7-5.085-2.34-6.592-7.267-6.592Z",
    transform: "translate(30.502 2.813)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M9.163,25.875A9.025,9.025,0,0,1,.051,15.817L.658,9.63C1.6,2.768,4.686,0,11.3,0h6.862a1.726,1.726,0,0,1,1.26.563,1.652,1.652,0,0,1,.428,1.3L18.276,17.64A9.367,9.367,0,0,1,9.163,25.875ZM11.3,3.375c-4.928,0-6.57,1.485-7.29,6.637L3.4,16.155A5.635,5.635,0,0,0,9.163,22.5,5.962,5.962,0,0,0,14.9,17.3L16.3,3.375Z",
    transform: "translate(3.527 2.813)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M12.938,14.625H1.688A1.7,1.7,0,0,1,0,12.938V7.313C0,2.588,2.588,0,7.313,0s7.313,2.588,7.313,7.313v5.625A1.7,1.7,0,0,1,12.938,14.625ZM3.375,11.25H11.25V7.313c0-2.835-1.1-3.937-3.937-3.937s-3.937,1.1-3.937,3.938Z",
    transform: "translate(19.688 36.563)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H54V54H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.cbfabeb82653e3e64492bdafe2740c7a.svg";
export { ForwardRef as ReactComponent };